import { ReactElement, useMemo } from 'react';

import { Patient, PatientQuery } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { TranslatableText } from '@dreryk/react-common';
import { ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { translationKeys } from '../translations';

import { PatientNfzDepartmentUpdateModalContent } from './PatientNfzDepartmentUpdateModalContent';

type PatientNfzDepartmentUpdateShowModalEventInterceptorProps = {
   readonly patientId: number;
   readonly children: ReactElement;
   readonly modalLabel: TranslatableText;
};

export const PatientNfzDepartmentUpdateShowModalEventInterceptor = (
   props: PatientNfzDepartmentUpdateShowModalEventInterceptorProps
): JSX.Element => {
   const { data: patient } = useCqrsGet<Patient>(() => {
      const query = new PatientQuery();
      query.id = Slot.of(props.patientId);
      return query;
   });
   const shouldShowModal = useMemo(() => {
      return !patient?.nfzDepartment;
   }, [patient]);

   return (
      <ShowModalEventInterceptor
         title={translationKeys.missingNfzDepartment}
         modalWidth={ModalWidth.NORMAL}
         shouldShowModal={shouldShowModal}
         content={({ reject, resolve, closeModal }) => {
            return (
               <PatientNfzDepartmentUpdateModalContent
                  patientId={props.patientId}
                  onFault={reject}
                  modalLabel={props.modalLabel}
                  onSuccess={resolve}
                  onCancel={() => {
                     reject();
                     closeModal();
                  }}
               />
            );
         }}
         testId={'patientNfzDepartmentUpdate'}
         footerItemsHidden
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
